import * as types from "../constants/actionConstants";

const initialState = {
    createdBy: null,
    createdDate: null,
    lastModifiedBy: null,
    lastModifiedDate: null,
    //showTemplateKey: null,            // These properties come from the server
    //showAdditionalProperties: null,   // These properties come from the server
    //questionnaireTypeDisplayed: null, // These properties come from the server
    //allowCloning: null,               // These properties come from the server
    hideMetadataProperties: true,
    showQuestionRequired: true,
    loaded: false
};

function systemSettingReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_SYSTEM_SETTING:
            return {
                ...state,
                ...action.payload,
                loaded: true
            };
        case types.TOKEN_CLEAR:
        case types.TOKEN_REJECT_LOGIN:
            // On logout / rejected login, clear settings back to initial (avoid stale cross-user data)
            return {
                ...initialState
            };
        default:
            return state;
    }
}

export default systemSettingReducer;
